export enum AssetTableColumns {
  SHOWALL = 'SHOW ALL',
  Selected = 'Selected',
  ID = 'ID',
  NavigateTo = 'Navigate To',
  Label = 'Label',
  Status = 'Status',
  ToolType = 'Tool Type',
  ArchivedAt = 'Archived At',
}

export enum ExpandCategory {
  CREATE = 'Create',
  UPLOAD = 'Upload',
}

export enum EditType {
  SINGLE = 'SINGLE',
  BULK = 'BULK',
}

export enum FieldType {
  ID = 'ID',
  Label = 'LABEL',
  Tool = 'TOOL',
  Archived = 'ARCHIVED',
}
